import { Box, TextField } from '@material-ui/core';
import AppDialog from 'components/basic/AppDialog';
import { TraitsCtx } from 'pages/TraitsPage';
import React, { useContext, useState } from 'react';
import { useQueryClient, useMutation } from 'react-query';
import { SnpService } from 'services';
import { getTheme } from 'theme';

function CreateTraitDetailsSnpsDialog() {
  const { createTraitDetailSnpsDialog, closeCreateTraitDetailSnpsDialog } = useContext(TraitsCtx);
  const [ name, setName ] = useState('');
  const queryClient = useQueryClient();
  const createMutation = useMutation((snp) => { return SnpService.create(snp); }, {
    onSuccess: () => {
      return queryClient.invalidateQueries('snps').then(() => {
        closeCreateTraitDetailSnpsDialog();
      });
    },
  });
  return (
    <AppDialog
      title='Add new Snp'
      open={ createTraitDetailSnpsDialog.open }
      onClose={ () => { return closeCreateTraitDetailSnpsDialog(); } }
      onSubmit={ () => { return createMutation.mutate({ name }); } }
      loading={ createMutation.isLoading }
    >
      <Box style={ { padding: getTheme().spacing(2) } }>
        <TextField
          onChange={ (e) => {
            return setName(e.target.value);
          } }
          style={ { width: 300 } }
          label='Snp Name'
        />
      </Box>
    </AppDialog>
  );
}

export default CreateTraitDetailsSnpsDialog;
